import {
  FlowNodeBaseType,
  type FlowNodeEntity,
} from '@flowgram.ai/free-layout-editor';
import type { FlowNodeData } from '$/domains/workFlowV3/type';

/**
 * 判断节点是否处于模型任务执行中。
 */
export function isNodeTaskExecuting(node: FlowNodeEntity): boolean {
  const data = node.toJSON()?.data as FlowNodeData | undefined;
  return Boolean(
    data?.modelTaskExecuteStatus === 'pending'
    || data?.modelUnfinishedTasks?.length,
  );
}

/**
 * 判断群组内是否存在正在执行中的子节点。
 */
export function isGroupTaskExecuting(groupNode: FlowNodeEntity): boolean {
  const blocks = groupNode.blocks ?? [];
  return blocks.some((block) => isNodeTaskExecuting(block));
}

/**
 * 判断群组节点是否处于执行中（组内存在执行中的子节点）。
 */
export function isExecutingGroupNode(node: FlowNodeEntity): boolean {
  return node.flowNodeType === FlowNodeBaseType.GROUP && isGroupTaskExecuting(node);
}

/**
 * 获取节点所在的执行态群组父节点。
 */
function getExecutionParentGroupNode(node: FlowNodeEntity): FlowNodeEntity | undefined {
  const { parent } = node;
  if (!parent || parent.flowNodeType !== FlowNodeBaseType.GROUP) {
    return undefined;
  }
  return parent;
}

/**
 * 判断节点是否位于正在执行中的群组内。
 */
export function isNodeInsideExecutingGroup(node: FlowNodeEntity): boolean {
  const parentGroup = getExecutionParentGroupNode(node);
  if (!parentGroup) {
    return false;
  }
  return isGroupTaskExecuting(parentGroup);
}

/**
 * 判断节点是否受执行中群组约束（群组本身执行中，或位于执行中群组内）。
 */
export function isUnderExecutingGroupConstraint(node: FlowNodeEntity): boolean {
  return isExecutingGroupNode(node) || isNodeInsideExecutingGroup(node);
}

/**
 * 判断节点删除是否应被执行中任务拦截；交互白名单不影响删除保护。
 */
export function isNodeDeletionBlockedWhileExecuting(node: FlowNodeEntity): boolean {
  return isNodeTaskExecuting(node) || isUnderExecutingGroupConstraint(node);
}
